import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
var BASE_ASSET_KEY = 'assets';
var assetKeys = {
  assets: [BASE_ASSET_KEY],
  singleAsset: function singleAsset(assetId) {
    return [BASE_ASSET_KEY, Number(assetId)];
  },
  myAsset: function myAsset(assetId, playlistId) {
    return [BASE_ASSET_KEY, Number(assetId), 'my', Number(playlistId)];
  },
  myAssetPlaylists: function myAssetPlaylists(assetId) {
    return [BASE_ASSET_KEY, Number(assetId), 'my', 'playlist'];
  },
  myAssetStatuses: function myAssetStatuses(assetId) {
    return [BASE_ASSET_KEY, Number(assetId), 'my', 'statuses'];
  },
  userAssets: function userAssets(userId, search) {
    return [BASE_ASSET_KEY, 'user', Number(userId), String(search)];
  },
  allAssetAnalytics: [BASE_ASSET_KEY, 'analytics'],
  assetAnalytics: function assetAnalytics(assetId, period) {
    return [].concat(_toConsumableArray(assetKeys.allAssetAnalytics), ['history', assetId, period]);
  },
  assetPopularUsers: function assetPopularUsers(assetId, parentId, collectionId) {
    return [].concat(_toConsumableArray(assetKeys.allAssetAnalytics), ['popularUsers', assetId, parentId, collectionId]);
  },
  assetActivityLogs: function assetActivityLogs(assetId, parentId) {
    return [].concat(_toConsumableArray(assetKeys.allAssetAnalytics), ['activityLogs', assetId, parentId]);
  },
  popularAssets: function popularAssets(parentId, playlistId) {
    return [].concat(_toConsumableArray(assetKeys.allAssetAnalytics), ['popularAssets', parentId, playlistId]);
  },
  assetSharePermissions: function assetSharePermissions(assetIds) {
    return [BASE_ASSET_KEY, 'share-permissions', assetIds === null || assetIds === void 0 ? void 0 : assetIds.toString()];
  }
};
export default assetKeys;